import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextLineValidity = /** @class */ (function (_super) {
    __extends(TextLineValidity, _super);
    function TextLineValidity() {
        return _super.call(this) || this;
    }
    TextLineValidity.forceNativeConstructor = true;
    TextLineValidity.forceNativeMethods = true;
    // JS -> AS Bindings
    TextLineValidity.VALID = 'valid';
    TextLineValidity.POSSIBLY_INVALID = 'possiblyInvalid';
    TextLineValidity.INVALID = 'invalid';
    TextLineValidity.STATIC = 'static';
    return TextLineValidity;
}(ASObject));
export { TextLineValidity };
